(function ($) {
	'use strict'

	$(document).ready(function () {
		// expand animation function
		function autoHeightAnimate (element, time) {
			const curHeight = element.height() // Get Default Height
			const autoHeight = element.css('height', 'auto').height() // Get Auto Height
			element.height(curHeight) // Reset to Default Height
			element.stop().animate({ height: autoHeight }, time) // Animate to Auto Height
		}

		// ! menu
		const $menuContainer = $('.site-header')
		const menuHasChildren = '.site-header #site-navigation .menu-item.menu-item-has-children'
		const menuItem = '.menu-item.menu-item-has-children'
		const mobileMenuButton = '.site-header #site-navigation .menu-button'
		const animateTime = 200
		// toggle
		$(mobileMenuButton).click(function () {
			if ($menuContainer.hasClass('mobile-menu-open')) {
				$(mobileMenuButton).attr('aria-expanded', 'false')
				$menuContainer.removeClass('mobile-menu-open')
				$menuContainer.stop().animate({ height: '104px' }, animateTime)
			} else {
				$menuContainer.addClass('mobile-menu-open')
				$(mobileMenuButton).attr('aria-expanded', 'true')
				autoHeightAnimate($menuContainer, animateTime)
			}

		return false
		})

		$(window).resize(function () {
			if ($(window).width() > 992) {
				// Clear out mobile-menu.
				$menuContainer.css('height', '')
			} else if ($menuContainer.hasClass('mobile-menu-open')) {
				$menuContainer.css('height', 'auto')
				$(menuHasChildren + '.menu-open').removeClass('menu-open').attr('aria-expanded', 'false')
			}
		})

		// click open drop-down menu
		// ----------------------------------------------
		// add accessibly attribute
		$(menuHasChildren).attr({
			'aria-expanded': 'false',
			'aria-haspopup': 'true'
		})
		// Show menu as expaned on load if active child menu-item.
		if ($(window).outerWidth() < 993) {
			$(menuHasChildren + '.current-menu-parent').addClass('menu-open').attr('aria-expanded', 'true')
		}
		// toggle
		$(menuHasChildren + ' > a').click(function () {
			const $this = $(this)
			if ($this.parents(menuItem).hasClass('menu-open')) {
				$this.parents(menuItem).addClass('fade-out').removeClass('menu-open').attr('aria-expanded', 'false')
				setTimeout(function () {
					$this.parents(menuItem).removeClass('fade-out')
				}, 200)
				if ($(window).outerWidth() < 993) {
					$menuContainer.css('height', 'auto')
				}
			} else {
				$(menuHasChildren).removeClass('menu-open').attr('aria-expanded', 'false')
				$this.parents(menuItem).addClass('fade-in').attr('aria-expanded', 'true')
				setTimeout(function () {
					$this.parents(menuItem).addClass('menu-open').removeClass('fade-in')
					if ($(window).outerWidth() < 993) {
						autoHeightAnimate($menuContainer, animateTime)
					}
				}, 100)
			}

			return false
		})

		// Hide drop-down menu on outside click
		$(document).on('click', function (e) {
			if ($(window).width() > 992) {
				if ($(menuHasChildren).hasClass('menu-open') && $(e.target).closest(menuHasChildren + ' .menu').length === 0) {
					$(menuHasChildren).addClass('fade-out').removeClass('menu-open').attr('aria-expanded', 'false')
					setTimeout(function () {
						$(menuHasChildren).removeClass('fade-out')
					}, 200)
				}
			}
		})

		// Hide drop-down menu by pressing the ESC key
		$(document).on('keyup', function (e) {
			if ($('.menu-item.menu-item-has-children').hasClass('menu-open') && e.keyCode === 27) {
				$('.menu-item.menu-item-has-children').addClass('fade-out').removeClass('menu-open').attr('aria-expanded', 'false')
				setTimeout(function () {
					$('.menu-item.menu-item-has-children').removeClass('fade-out')
				}, 200)
			}
		})
		// end menu

		// ! Sticky header
		const distance = $('.site-header').height() - 75
		$(window).scroll(function () {
			if ($(window).scrollTop() >= distance) {
				$('#page').addClass('page-scrolled')
			} else {
				$('#page').removeClass('page-scrolled')
			}
		})

		// ! Problems and Solutions smooth scroll jump menu with offset
		const typefiProblemsSolutions = document.querySelector('.typefi-problems-solutions')
		const typefiBlockDocumentation = document.querySelector('.page-id-13658')
		if (typefiProblemsSolutions || typefiBlockDocumentation) {
			const problemSolutionJumpMenu = document.querySelectorAll('.typefi-problem-solution-navigation ul a')
			const solutionJumpMenu = document.querySelectorAll('.jump-solution a')
			const docsJumpMenu = document.querySelectorAll('.toc a')

			function jumpClick (jumpEl) {
				jumpEl.forEach(anchor => {
					anchor.addEventListener('click', function (e) {
						const jumpAnchor = anchor.getAttribute('href')
						const jumpSection = document.querySelector(jumpAnchor);
						const jumpOffset = ($(window).width() > 992) ? 138 : 0
						const jumpBodyRect = document.body.getBoundingClientRect().top
						const jumpElementRect = jumpSection.getBoundingClientRect().top
						const jumpElementPosition = jumpElementRect - jumpBodyRect
						const jumpOffsetPosition = jumpElementPosition - jumpOffset

						window.scrollTo({
							top: jumpOffsetPosition,
							behavior: 'smooth'
						})

						e.preventDefault()
					})
				})
			}

			jumpClick(problemSolutionJumpMenu)
			jumpClick(solutionJumpMenu)
			jumpClick(docsJumpMenu)
		}

		// ! Solution finder scroll with offset
		const anchorHash = window.location.hash
		if ($(window).width() > 992 && anchorHash) {
			// Wait for the content to load
			$(window).load(function () {

				// Scroll to the position
				const hashSection = document.querySelector(anchorHash)
				const hashOffset = ($(window).width() > 992) ? 138 : 0
				const hashBodyRect = document.body.getBoundingClientRect().top
				const hashElementRect = hashSection.getBoundingClientRect().top
				const hashElementPosition = hashElementRect - hashBodyRect
				const hashOffsetPosition = hashElementPosition - hashOffset

				window.scrollTo({
					top: hashOffsetPosition,
					behavior: 'smooth'
				})
			})
		}

		// ! Back to top
		if (typefiBlockDocumentation) {
			// Create back-to-top button
			const backTopButton = document.createElement('button')
			backTopButton.innerText = 'Back to Top'
			backTopButton.id = 'back-top-button'
			const pageDiv = document.getElementById('page')
			pageDiv.appendChild(backTopButton)
			// Scroll event
			const backTopBtn = document.getElementById('back-top-button')
			backTopBtn.addEventListener('click', function (e) {

				window.scrollTo({
					top: 0,
					behavior: 'smooth'
				})

				e.preventDefault()
			})
		}

		// ! Video play / pause
		const localStorage = window.localStorage
		const videoWrap = document.querySelector('.typefi-page-intro-video-file-wrap')
		const playPauseBtn = document.querySelector('.typefi-page-intro-video-file-wrap .playpause')
		const player = document.querySelector('.typefi-page-intro-video-file video')

		const playVideo = function () {
			player.play()
			playPauseBtn.textContent = 'Pause video'
			playPauseBtn.classList.remove('pause')
			playPauseBtn.classList.add('play')
		}
		const pauseVideo = function () {
			player.pause()
			playPauseBtn.textContent = 'Play video'
			playPauseBtn.classList.remove('play')
			playPauseBtn.classList.add('pause')
		}

		if ( videoWrap ) {

			// Remember play state using localStorage
			if (localStorage.getItem('playerState') === null) {
				localStorage.setItem('playerState', 'play')
				const getPlayerState = localStorage.getItem('playerState')
				playPauseBtn.classList.add(getPlayerState)
			} else {
				const getPlayerState = localStorage.getItem('playerState')
				if (getPlayerState === 'play') {
					playVideo()
				} else {
					pauseVideo()
				}
				playPauseBtn.classList.add(getPlayerState)
			}

			// Play pause button
			playPauseBtn.onclick = function () {
				if (player.paused) {
					playVideo()
					localStorage.setItem('playerState', 'play')
				} else {
					pauseVideo()
					localStorage.setItem('playerState', 'pause')
				}
			}
		}

		// ! basictable - provides responsive layout for html tables.
		new basictable('.wp-block-table table', {
			breakpoint: 768,
		})

		new basictable('.uk-table', {
			breakpoint: 768,
		})

		// In basictable mobile view, the header images don't display because
		// of the css pseudo method used. So we find each image, get its path,
		// and create a CSS background image for each header cell used in the
		// basictable mobile view.
		const comparisonTable = '.wp-block-table.typefi-comparison-table'
		// Create style tag.
		if ($(comparisonTable + ' table th').find('img').length) {
			$('<style></style>').prependTo(comparisonTable)
		}
		// loop through and get image paths.
		$(comparisonTable + ' table th').each(function () {
			if ($(this).find('img').length) {
				const thImgSrc = $(this).find('img').attr('src')
				const thIndex = $(this).index() + 1
				// Add CSS to style tag.
				$(comparisonTable + ' style').append(comparisonTable + ' table tr td:nth-child(' + thIndex + ')::before { background-image: url("' + thImgSrc + '")}')
			}
		})
	})
})(window.jQuery)
